import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcCarretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	style: { isolation: "isolate" },
	viewBox: "562.135 187.23 11.879 5.939",
	width: "11.879pt",
	height: "5.939pt",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: " M 574.014 187.23 L 568.075 193.169 L 562.135 187.23 L 574.014 187.23 Z " })
});
export default SvgIcCarretDown;
